// Loader.js
import React from 'react';
import './Loader.css'

const Loader = () => (
  <div className="loader">
    <img src="images/m.gif" alt="Loading" />
  </div>
);

export default Loader;
